import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './index.css';
import { DashBoardTitle } from '../../Title';
import { Col, Container, Row, Table } from 'reactstrap';
import WhatsApp from '../../../images/whatsapp.png';
import gmail from '../../../images/gmail.png';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import Pagination from '../../Pagination/Pagination';
import { getDealerEngagementWithStatus } from '../../../constants/apiCalls';
import Storage from '../../../services/Storage';
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import { UserFilters } from '../../Filters';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import DateService from '../../../services/DateService';
import { messages } from '../../../utils/constant-messages';
import { useNavigate } from 'react-router-dom';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

export function DealerMAnnivTable() {

  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';
  useEffect(() => {
    if (!localPermission.includes(Permissions.DEALER_MARRIAGE_ANNIVERSARY)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getMAnniversaryPage(), [Storage.getMAnniversaryPage()]);
  const [object, setObject] = useState('');
  const [engagementData, setEngagementData] = useState([]);

  // Page
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  // Date
  const [startDate, setStartDate] = useState(Storage.getDashboardCurrentDate() ? Storage.getDashboardCurrentDate() : ''
  );
  const [endDate, setEndDate] = useState(Storage.getDashboardCurrentDate() ? Storage.getDashboardCurrentDate() : ''
  );
  const [isLoading, setIsloading] = useState(false);

  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    []
  );

  useEffect(() => { }, [userData]);

  const getDealerData = useCallback(
    (obj, page, pageSize) => {
      setIsloading(true);
      setObject(obj);
      let payload = {
        q: obj.searchQuery || '',
        pagesize: pageSize,
        page: page || 1,
        type: 'marriage_anniversary',
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        is_download: false,
      };
      getDealerEngagementWithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setEngagementData(data.data);
          let count = data.total_count;
          setCount(count);
          let totalPages = Math.ceil(count / pageSize);
          setTotalPages(totalPages);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handleExcelSheet = useCallback(
    (obj, page, pageSize) => {
      let payload = {
        q: obj.searchQuery || '',
        pagesize: 100000,
        page: page || 1,
        type: 'marriage_anniversary',
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        is_download: true,
      };
      getDealerEngagementWithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          window.open(data.file, '_blank');
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setMAnniversaryPage(Number(page));
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const handleWpMessage = (val) => {
    let vals = val;
    window.open('https://web.whatsapp.com/send?phone=91' + vals, '_blank');
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='mAnnivTable'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>

                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Dealer Marriage Anniversary' />
                        <BreadCrumbBackButton />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='Dealer Marriage Anniversary' />
                    </Col>
                    <Col xs={12}>
                      <UserFilters
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageNo={pageNo}
                        userData={userData}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dealerData={getDealerData}
                        excelData={handleExcelSheet}
                      />
                    </Col>
                  </Row>
                  {engagementData && engagementData.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table bordered className='table text-center'>
                            <thead>
                              <tr>
                                <th>Dealer Code</th>
                                <th>Dealership Name</th>
                                <th>Owner Name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                {(roleName === Roles.NH_NAME ||
                                  roleName === Roles.BH_NAME) && <th>State</th>}
                                {(roleName === Roles.NH_NAME ||
                                  roleName === Roles.BH_NAME) && <th>TM</th>}
                                <th>Anniversary Date</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {engagementData.map((elem, index) => {
                                const {
                                  dealer_code,
                                  business_name,
                                  primary_contact_name,
                                  primary_contact_mobile,
                                  primary_contact_email,
                                  wedding_date,
                                  state,
                                  th,
                                } = elem;
                                return (
                                  <tr key={index}>
                                    <td>{dealer_code}</td>
                                    <td>
                                      <span>{business_name}</span>
                                    </td>
                                    <td>{primary_contact_name}</td>
                                    <td>{primary_contact_mobile}</td>
                                    <td>{primary_contact_email}</td>
                                    {(roleName === Roles.NH_NAME ||
                                      roleName === Roles.BH_NAME) && <td>{state}</td>}
                                    {(roleName === Roles.NH_NAME ||
                                      roleName === Roles.BH_NAME) && <td>{th}</td>}
                                    <td>{DateService.localDateOnly(wedding_date) || 'N/A'}</td>
                                    <td>
                                      <div className='iconBlock'>
                                        <img
                                          src={WhatsApp}
                                          alt='whatsapp'
                                          onClick={() =>
                                            handleWpMessage(primary_contact_mobile)
                                          }
                                          className='iconImg'
                                        />
                                        <img
                                          src={gmail}
                                          alt='gmail'
                                          className='iconImg'
                                          onClick={() =>
                                            (window.location = `mailto:${primary_contact_email}?subject=Test Subject&body=`)
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
